// Helper for creating a schema that supports tables.

import { type NodeType, type Schema } from '@tiptap/pm/model';

/**
 * @public
 */
export type TableRole = 'wordTable' | 'wordRow' | 'wordCell';

/**
 * @public
 */
export function tableNodeTypes(schema: Schema): Record<TableRole, NodeType> {
    let result = schema.cached.tableNodeTypes;
    if (!result) {
        result = schema.cached.tableNodeTypes = {};
        for (const name in schema.nodes) {
            const type = schema.nodes[name],
                role = type.spec.tableRole;
            if (role) result[role] = type;
        }
    }
    return result;
}
